import Vue from 'vue'
import { MutationTree } from 'vuex'
import { IUserState, IUserInfo } from './types'

const mutations: MutationTree<IUserState> = {
  SET_USER_INFO (state, payload: IUserInfo) {
    Vue.set(state, 'userInfo', payload)
  },

  CHANGE_DEVELOPER_EMAIL (state, payload: string) {
    if (state.userInfo && state.userInfo.developer) {
      state.userInfo.developer.email = payload
    }
  },
  /**
   * 设置当前选中的企业
   */
  SET_CUR_ENTERPRISE (state, payload) {
    Vue.set(state, 'curEnterprise', payload)
  },
  SET_ALL_DEVELOPERS (state, payload) {
    Vue.set(state, 'developerList', payload)
  }
}

export default mutations
